import { render, staticRenderFns } from "./BrochureSection.vue?vue&type=template&id=b1767bf4&"
import script from "./BrochureSection.vue?vue&type=script&lang=js&"
export * from "./BrochureSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports